<template>
<div id="clients-section" class="flex items-center justify-center my-20 sm:my-24 lg:mt-32 lg:mb-48 flex-col">
    <h2 :class="titleClass">
        {{ title }}
    </h2>
    <div id="indicators-carousel-clients" class="relative w-full xl:w-[85%]">
        <div ref="carousel-clients" id="clientsCarousel" class="relative mb-4 sm:mb-12 clients-carousel overflow-hidden rounded-lg">
            <div id="carousel-item-clients5" class="hidden  bg-white duration-700 ease-in-out" data-carousel-item="active">
                <div class="flex items-center h-full flex-col lg:flex-row mt-3">
                    <div class="sm:w-1/2 md:w-8/12 lg:w-1/2 w-full flex justify-center">
                        <div class="video-container max-sm:flex max-sm:items-center">
                            <div v-if="showPlayButton" class="play-button" id="play-button" @click="showVideo">
                                <img alt="" class="play lazyload" data-src="../../../images/play.png" />
                                <img alt="vide-img" class="video-img max-sm:h-auto lazyload" data-src="../../../images/video-img.webp" />
                            </div>
                            <div id="player"></div>
                        </div>
                    </div>
                    <slot name="clientopinion1"></slot>
                </div>
            </div>
            <div id="carousel-item-clients6" class="hidden bg-white duration-700 ease-in-out" data-carousel-item>
                <slot name="clientopinion2"></slot>
            </div>
            <div id="carousel-item-clients7" class="hidden bg-white duration-700 ease-in-out" data-carousel-item>
                <slot name="clientopinion3"></slot>
            </div>
            <div id="carousel-item-clients8" class="hidden bg-white duration-700 ease-in-out" data-carousel-item>
                <slot name="clientopinion4"></slot>

            </div>
            <div id="carousel-item-clients9" class="hidden bg-white duration-700 ease-in-out" data-carousel-item>
                <slot name="clientopinion5"></slot>

            </div>
        </div>
        <div class="flex items-center space-x-12 sm:mt-8 justify-center">
            <button aria-label="previous arrow" @click="showPreviousSlide" id="clientsCarouselPrev" class="border border-grayBorder hover:border-mainColor rounded-full flex mr-2 items-center justify-center w-14 h-14 cursor-pointer group
                            focus:outline-none transition duration-200">
                <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6" fill="none" stroke="currentColor" stroke-width={1.5} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></path>
                </svg>
            </button>
            <div class="flex space-x-3 justify-center">
                <button id="carousel-indicator-clients5" class="slider max-sm:pointer-events-none" aria-current="true" aria-label="Slide 1" data-carousel-slide-to="0"></button>
                <button id="carousel-indicator-clients6" class="slider max-sm:pointer-events-none" aria-current="false" aria-label="Slide 2" data-carousel-slide-to="1"></button>
                <button id="carousel-indicator-clients7" class="slider max-sm:pointer-events-none" aria-current="false" aria-label="Slide 3" data-carousel-slide-to="2"></button>
                <button id="carousel-indicator-clients8" class="slider max-sm:pointer-events-none" aria-current="false" aria-label="Slide 4" data-carousel-slide-to="3"></button>
                <button id="carousel-indicator-clients9" class="slider max-sm:pointer-events-none" aria-current="false" aria-label="Slide 5" data-carousel-slide-to="4"></button>
            </div>
            <button aria-label="next arrow" @click="showNextSlide" id="clientsCarouselNext" class="border border-grayBorder hover:border-mainColor rounded-full transition duration-200 flex ml-2 items-center justify-center w-14 h-14 cursor-pointer group focus:outline-none">
                <svg aria-hidden="true" class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6" fill="none" stroke="currentColor" stroke-width={1.5} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                </svg>
            </button>
        </div>
    </div>
</div>
</template>

<script>
import { Carousel } from "flowbite";
import YouTubePlayer from "youtube-player";
export default {
    name: "Clients",
    data() {
        return {
            touchStartXClients: 0,
            touchEndXClients: 0,
            carouselClients: null,
            player: null,
            playerState: -1,
            showPlayButton: true,
        };
    },
    mounted() {
        const itemsClients = [{
                position: 0,
                el: document.getElementById("carousel-item-clients5"),
            },
            {
                position: 1,
                el: document.getElementById("carousel-item-clients6"),
            },
            {
                position: 2,
                el: document.getElementById("carousel-item-clients7"),
            },
            {
                position: 3,
                el: document.getElementById("carousel-item-clients8"),
            },
            {
                position: 4,
                el: document.getElementById("carousel-item-clients9"),
            },
        ];

        const optionsClients = {
            defaultPosition: 0,
            interval: 5000,
            indicators: {
                items: [{
                        position: 0,
                        el: document.getElementById("carousel-indicator-clients5"),
                    },
                    {
                        position: 1,
                        el: document.getElementById("carousel-indicator-clients6"),
                    },
                    {
                        position: 2,
                        el: document.getElementById("carousel-indicator-clients7"),
                    },
                    {
                        position: 3,
                        el: document.getElementById("carousel-indicator-clients8"),
                    },
                    {
                        position: 4,
                        el: document.getElementById("carousel-indicator-clients9"),
                    },
                ],
            },
        };
        this.carouselClients = new Carousel(itemsClients, optionsClients);

        this.carouselClients.cycle();

        const carouselClientsElement = document.getElementById("clientsCarousel");

        const handleTouchStartClients = (event) => {
            this.touchStartXClients = event.touches[0].clientX;
        }

        const handleTouchEndClients = (event) => {
            this.touchEndXClients = event.changedTouches[0].clientX;
            handleSwipeClients();
        }

        const handleSwipeClients = () => {
            const swipeThreshold = 50;
            const swipeDistance = this.touchEndXClients - this.touchStartXClients;

            if (swipeDistance > swipeThreshold) {
                this.carouselClients.prev();
            } else if (swipeDistance < -swipeThreshold) {
                this.carouselClients.next();
            }
        }

        carouselClientsElement.addEventListener("touchstart", handleTouchStartClients, { passive: true });
        carouselClientsElement.addEventListener("touchend", handleTouchEndClients, { passive: true });
    },
    computed: {
        title() {
            if (window.location.pathname === "/industries/ecommerce-and-online-stores") {
                return "What Our Clients Say About Our eCommerce App Development Company"
            } else if (window.location.pathname === "/industries/food-delivery") {
                return "What Our Clients Say About Food Ordering App Development Company"
            } else if (window.location.pathname === "/industries/elearning") {
                return "What Our Clients Say About Elearning Development Company"
            } else {
                return "What Our Clients Say About Us"
            }
        },
        titleClass() {
            return window.location.pathname === '/industries/ecommerce-and-online-stores' || window.location.pathname === "/industries/elearning" || window.location.pathname === "/industries/food-delivery" ? 'font-semibold text-center leading-12 w-full lg:w-4/5 font-trap text-28 leading-8 sm:leading-[46px] sm:text-40' : 'font-semibold text-center w-full lg:w-1/3 leading-8 sm:leading-[46px] sm:w-3/5 font-trap text-28 sm:text-40';
        }
    },
    methods: {
        showVideo() {
            this.carouselClients.pause();
            this.loadYouTubeApi();
            // this.initializeYouTubePlayer();
        },
        initializeYouTubePlayer() {
            this.player = YouTubePlayer("player", {
                height: "302",
                width: "475",
                videoId: "Aaaf014Sq6c",
                playerVars: {
                    autoplay: 0,
                    controls: 0,
                    autohide: 1,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                },
            })

            this.player.on("stateChange", (event) => {
                if (event.data === 2 || event.data === 0) {
                    this.carouselClients.cycle();
                } else if (event.data === 1) {
                    this.carouselClients.pause();
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.showPlayButton = false;
                    }, 250);
                });
                this.playerState = event.data;
            })
            this.player.playVideo()
        },
        loadYouTubeApi() {
            if (!document.getElementById('youtube-api-script')) {
                const script = document.createElement('script');
                script.id = 'youtube-api-script';
                script.src = 'https://www.youtube.com/iframe_api';
                script.async = true;
                script.nonce = "{{ csp_nonce() }}";

                script.onload = () => {
                    this.initializeYouTubePlayer();
                };

                document.head.appendChild(script);
            } else {
                this.initializeYouTubePlayer();
            }
        },
        showNextSlide() {
            this.pauseByState();
            this.carouselClients.next();
        },
        showPreviousSlide() {
            this.pauseByState();
            this.carouselClients.prev();
        },
        pauseByState() {
            if (this.playerState >= 1) {
                this.player.pauseVideo();
            }
        }
    },
};
</script>
